"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warn = exports.deprecate = exports.default = void 0;
const deprecate = (componentName, message) => {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  console.warn(`[Allium] [Deprecate] ${componentName}: ${message}`);
};
exports.deprecate = deprecate;
const warn = (componentName, message) => {
  if (process.env.NODE_ENV === 'production') {
    return;
  }
  console.warn(`[Allium] ${componentName}: ${message}`);
};
exports.warn = warn;
var _default = exports.default = {
  deprecate,
  warn
};